import React, {createContext, useState} from "react";
import domesticProjects from "../Data/DomesticProjects";
import commercialProjects from "../Data/CommercialProjects";

export const ProjectsContext = createContext(null);
export const ProjectsProvider = ({children}) => {
    const [projects, setProjects] = useState([]);
    const [currentType, setCurrentType] = useState('');

    const setProjectsForType = (type, dataArray = null) => {
        setCurrentType(type);

        if (dataArray) {
            setProjects(dataArray);
        } else {
            const normalized = type.toLowerCase();
            setProjects(normalized === "domestic" ? domesticProjects : commercialProjects);
        }
    };



    return (<ProjectsContext.Provider value={{projects, setProjectsForType, currentType}}>
            {children}
        </ProjectsContext.Provider>);
};